import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Button from "components/base/Button";
import { usePermissionModal } from "contexts/PermissionModalContext";
import { useEffect } from "react";

export default function ButtonRevisar() {
    const { getQueryRetryHandler, getMutationErrorHandler } = usePermissionModal();

    const revisaoQuery = useQuery({
        queryKey: ["revisaoRegrasFiscais"],
        queryFn: () => axios.get("/api/regraFiscal/revisando"),
        refetchInterval: 10000,
        retry: getQueryRetryHandler({
            queryKey: ["revisaoRegrasFiscais"],
            defaultMessage: "Você não possui permissão para revisar regras fiscais."
        }),
    });

    const revisaoMutation = useMutation({
        mutationFn: () => axios.post("/api/regraFiscal/revisar"),
        onError: getMutationErrorHandler("Você não possui permissão para revisar regras fiscais.")
    });


    const handleRevisar = async () => {
        await revisaoMutation.mutateAsync();
        revisaoQuery.refetch();
    };

    return (
        <Button
            variant="phoenix-secondary"
            loading={
                revisaoQuery.data?.data ||
                revisaoQuery.isLoading ||
                revisaoMutation.isPending
            }
            loadingPosition="start"
            onClick={handleRevisar}
        >
            Revisar
        </Button>
    )
}